<template>

  <div>
    <el-button style="float: right" type="primary" icon="el-icon-plus" @click="addContent()" >添加</el-button>
    <el-dialog title="添加" :visible.sync="dialogTableVisible" :append-to-body='true' :lock-scroll="false" >
      <AddContent></AddContent>
    </el-dialog>
    <div class="policyClass">
      <el-table :data="company" class="tb-edit" style="margin:0 auto">
        <el-table-column prop="id" label="id" style="width:25%">
        </el-table-column>
        <el-table-column prop="sort" label="图片顺序" style="width:25%">
        </el-table-column>
        <el-table-column prop="content" label="图片内容" style="width:25%">
        </el-table-column>
        <el-table-column prop="date" label="上传时间" style="width:25%">
          <template slot-scope="scope">
            {{scope.row.date | moment}}
          </template>
        </el-table-column>
        <el-table-column prop="state" label="状态" style="width:25%">
          <template slot-scope="scope">
            <p v-if="scope.row.state == 1" style="color:green;">启用</p>
            <p v-else style="color:red;">禁用</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" style="width:25%">
          <el-switch
            v-model="rohs"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
          <el-button size="small" style="color:red" >删除</el-button>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import AddContent from "./AddContent";
  // import UpdateAdmin from "./UpdateAdmin";
  export default {
    components: {
      AddContent
    },
    data(){
      return {
        rohs: true,
        dialogTableVisible: false,
        company:[]
      }
    },
    mounted(){

    },
    methods:{

      addContent(){
        this.dialogTableVisible = true;//默认页面不显示为false,点击按钮将这个属性变成true
      },
      // save(){
      //   this.$router.replace({path:'/'})
      // }
    }
  }
</script>

<style scoped>
</style>
